import { Box, styled } from '@mui/material';
import { BaseCard } from 'console/shared/styles/mixins/base-card';
import { ControlButton } from '../../../buttons/control';
export const GuardZoneCard = styled(BaseCard)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
});
export const GuardSensors = styled(Box)(({ multiplier }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(${multiplier * 170}px, 1fr))`,
    gridTemplateRows: 'repeat(auto-fill, minmax(90px, 1fr))',
    gap: 8,
}));
export const GuardSensor = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    padding: 0,
}));
export const GuardZoneButton = styled(ControlButton)({});
